import { Injectable } from '@angular/core';
import { BaseNotifier } from '@app/core/service/base-notifier';
import { MessageService } from 'primeng/api';
import { INotifierMessage } from '@app/core/interface/notifier';

@Injectable({ providedIn: 'root' })
export class SnackNotifier extends BaseNotifier {

  /**
   * @param {MessageService} message
   */
  constructor(private readonly message: MessageService) {
    super();
  }

  public success(detail: string): void {
    this.message.add({
      severity: 'success',
      closable: false,
      life: 2000,
      detail,
    });
  }

  public info(detail: string): void {
    this.message.add({
      severity: 'info',
      closable: false,
      life: 2000,
      detail,
    });
  }

  public error(message: INotifierMessage): void {
    this.message.add({
      severity: 'error',
      closable: false,
      life: 4000,
      detail: this.getMessage(message),
    });
  }
}
